// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1zFlg","info":"PatientInfo_info__2ZlAR"};